import React from 'react';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import { DOCUMENT_TYPE_OPTIONS } from '../../constants';

const DocumentTypeFilter = () => (
  <IconFilter
    hasApplyButton
    name="documentType"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={DOCUMENT_TYPE_OPTIONS}
  />
);

export default DocumentTypeFilter;
